import { outboundConstants } from '../../_constants';
import { outboundServices } from '../../_services';
import { alertActions, inboundActions, confirmPromptActions, notificationActions, userActions, } from '../index';
import { CTSANDCBS, WayBill, ATW, } from '../../../components/layout/OutBoundPdf/AllOutBoundPdf';
import { LoadingReport, 
    // CargoCostingManifest, 
    CoastingManifest } from '../../../components/layout/OutBoundExcel/AllOutBoundExcel';
import { StowagePlanPdf } from '../../../components/layout/OutBoundPdf/AllOutBoundPdf';

export const outboundActions = {
    //atw
    searchBookingATW, // Booking List
    getCyBranch, // get cy by branch
    getBookingForATW, // get booking
    updateBookingATW,

    //cts
    getBookingForCBS, // for printing
    loadCts,
    getCTS,
    getBookingForCTS, // get booking for cts
    getBookingForCTSTandem, // get booking tandem for cts

    createBookingCts,
    updateCTSNum,
    deleteByCTSNum,

    //waybill
    clearWaybill,
    loadWayBill,
    getWayBill,
    getWayBillTandem, // get waybill tandem
    getBookingForWayBill, // get booking for create
    getBookingForWayBillTandem, 
    createWayBill,
    createWayBillTandem,
    updateWayBillRef,
    deleteByWayBill,
    shipperOwnContainerCts,
    updateShipperOwnCVCts,
    generateExemptionCharge,
    generateExemptionChargeTandem,

    //build Up
    getWayBIllBuildUp,// outbound build up list
    getWayBillByVoyageNum,
    isWithPermit,

    //loadlist
    clearLoadList, //clear load list
    groupWayBillbyRelease, //show loadlist release list
    updateLoadListReleaseType, //update release either partial or final
    deleteLoadListByRelease, // delete loadlist release
    createLoadList, // create loadlist release
    getWayBillReleaseType, // get loadlist by release
    acknowledgeRelease, // confirm / acknowledge release
    updateLoadList, // add and cancel for release and revisions

    //tallysheet
    readListTallySheetByVoyageNum, //get tallysheet by voyage num
    getTallySheetCode, //get tallysheet by code
    getListForTallySheet, //create tally sheet
    createTallySheet,
    updateTallySheet,
    createFinalTallySheet,
    updateFinalTallySheet,
    deleteByTallySheet,
    getVoyageLoadingReport, // for printing
    getVoyageLoadingReportTallysheet,
    getVoyageLoadingReportTallysheetReturnData,

    //stowage
    getListVoyageWithStowagePlan,
    getVoyageStowagePlan, //for create
    createStowagePlan,
    getStowagePlanCode,
    deleteByStowagePlanCode,
    updateStowagePlan,
    getVoyageNumPrintLoaded, // get for stowage plan printout

    //loading confirmation
    getLoadingConfirmationByVoyageNum,
    SentUnsent,

    //not use
    getAllCTS,
    moveWayBillRef,

    // Voyage List
    getVoyageBuildUp,
    getVoyageLoadList,
    getVoyageTallySheetList,
    getVoyageStowagePlanList,
    getVoyageLoadingConfirmationList,
    getVoyageWayBill,
    getVoyageForReguidingList,
    getVoyageCroAccounting,

    // Reguide
    getReguideVoyage,
    getVoyageScheduleForReguiding,
    changeVessel,
    voyageTransfer,

    resetlistForCreateTallySheet,

    // CRO Accounting
    getWayBIllWithDemmurage,
    getWayBIllCROAccounting,
    getWayBIllRefCROAccounting,
    updateCroAccounting,

    getPrevVoyage,

    Clear_Outbound,

    // Dispatch Module
    getDispacthList,
    updateOutDispatchList,
    sendOutDispatchList,
    archiveOutDispatchList,
    readArchiveOutDispatchList,

    exemptionChargeLoading,
    exemptionChargeLoaded,

    searchSalesInvoice,
}
function exemptionChargeLoading() { return { type: outboundConstants.EXEMPTION_CHARGE_LOADING } }
function exemptionChargeLoaded() { return { type: outboundConstants.EXEMPTION_CHARGE_LOADED } }

function outboundFetching() { return { type: outboundConstants.OUTBOUND_FETCHING } }
function outboundFetched() { return { type: outboundConstants.OUTBOUND_FETCHED } }

function outboundSubmitting() { return { type: outboundConstants.OUTBOUND_SUBMITTING } }
function outboundSubmitted() { return { type: outboundConstants.OUTBOUND_SUBMITTED } }

function isSuccess(isSuccess) { return { type: outboundConstants.OUTBOUND_SUCCESS, isSuccess } }

function clearLoadList() { return { type: outboundConstants.CLEAR_LOAD_LIST } }
function clearWaybill() { return { type: outboundConstants.CLEAR_WAYBILL } }
function resetlistForCreateTallySheet() { return { type: outboundConstants.CLEAR_CREATION_TALLYSHEET } }
function Clear_Outbound() { return { type: outboundConstants.CLEAR_OUTBOUND } }

function searchSalesInvoice(payload, customer) {
    return dispatch => {
        // dispatch(outboundFetching());
        outboundServices.searchSalesInvoice(payload)
            .then(
                SIList => {
                    dispatch(success({ list: SIList, customer: customer }));
                    // dispatch(outboundFetched());
                },
                error => {
                    // dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(SIList) { return { type: outboundConstants.SEARCH_SI, SIList } }
}

// Dispatch Module
function getDispacthList(payload) {
    return dispatch => {
        dispatch(outboundFetching());
        outboundServices.getDispacthList(payload)
            .then(
                DispatchList => {
                    dispatch(success(DispatchList));
                    dispatch(outboundFetched());
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(DispatchList) { return { type: outboundConstants.GET_DISPATCH_LIST, DispatchList } }
}
function updateOutDispatchList(payload) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        outboundServices.updateOutDispatchList(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    window.location.href = `/outbound/dispatchModule`;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}
function sendOutDispatchList(payload, load) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        outboundServices.sendOutDispatchList(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(outboundSubmitted());
                    dispatch(getDispacthList(load));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(outboundSubmitted());
                    dispatch(getDispacthList(load));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}
function archiveOutDispatchList(payload, load) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        outboundServices.archiveOutDispatchList(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(outboundSubmitted());
                    dispatch(getDispacthList(load));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}
function readArchiveOutDispatchList(payload) {
    return dispatch => {
        dispatch(outboundFetching());
        outboundServices.readArchiveOutDispatchList(payload)
            .then(
                ArchiveDispatchList => {
                    dispatch(success(ArchiveDispatchList));
                    dispatch(outboundFetched());
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(ArchiveDispatchList) { return { type: outboundConstants.GET_ARCHIVE_DISPATCH_LIST, ArchiveDispatchList } }
}
//atw
function getCyBranch(userBranch) {
    return dispatch => {
        dispatch(outboundFetching());
        outboundServices.getCyBranch(userBranch)
            .then(
                CyBranch => {
                    if (CyBranch.length > 0) {
                        dispatch(success(CyBranch));
                        dispatch(outboundFetched());
                    } else {
                        dispatch(alertActions.warning(CyBranch.message));
                        dispatch(outboundFetched());
                    }
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(CyBranch) { return { type: outboundConstants.CY_BRANCH, CyBranch } }
}
function searchBookingATW(search, branchCode) {
    return dispatch => {
        dispatch(outboundFetching());
        outboundServices.searchBookingATW(search, branchCode)
            .then(
                outboundBookingList => {
                    dispatch(success(outboundBookingList));
                    dispatch(outboundFetched());
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(outboundBookingList) { return { type: outboundConstants.OUTBOUND_BOOKING_LIST, outboundBookingList } }
}
function getBookingForATW(bookingRef, branchCode) {
    return dispatch => {
        dispatch(outboundFetching());
        outboundServices.getBookingForATW(bookingRef, branchCode)
            .then(
                outboundBookingAtw => {
                    if (outboundBookingAtw.length > 0) {
                        dispatch(success(outboundBookingAtw));
                        dispatch(outboundFetched());
                    } else {
                        dispatch(success([]));
                        dispatch(alertActions.warning(outboundBookingAtw.message));
                        dispatch(outboundFetched());
                    }
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(outboundBookingAtw) { return { type: outboundConstants.OUTBOUND_BOOKING_ATW, outboundBookingAtw } }
}
function updateBookingATW(payload, data, user) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        outboundServices.updateBookingATW(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.success('ATW was updated successfully'))
                    ATW(data, payload, user);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    }
}
//end of atw
//cts
function getBookingForCBS(bookingRef, branchCode) {
    return dispatch => {
        dispatch(outboundFetching());
        outboundServices.getBookingForCBS(bookingRef, branchCode)
            .then(
                outboundBookingCbs => {
                    if (outboundBookingCbs.length > 0) {
                        dispatch(success(outboundBookingCbs));
                        dispatch(outboundFetched());
                    } else {
                        dispatch(alertActions.warning(outboundBookingCbs.message));
                        dispatch(outboundFetched());
                    }
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(outboundBookingCbs) { return { type: outboundConstants.OUTBOUND_BOOKING_CBS, outboundBookingCbs } }
}
function loadCts(skip, take, filter, search, branch) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(userActions.allowLeavePage());
        outboundServices.loadCts(skip, take, filter, search, branch)
            .then(
                cts => {
                    if (cts.length > 0) {
                        dispatch(success(cts));
                        dispatch(outboundFetched());
                    } else {
                        dispatch(alertActions.warning(cts.message ? cts.message : 'No more data to load'));
                        dispatch(outboundFetched());
                    }
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(cts) { return { type: outboundConstants.LOAD_CTS, cts } }
}
function getCTS(CtsNum) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(userActions.allowLeavePage());
        outboundServices.getCTS(CtsNum)
            .then(
                outboundCts => {
                    if (outboundCts.length > 0) {
                        dispatch(success(outboundCts));
                        dispatch(outboundFetched());
                    } else {
                        dispatch(success([]));
                        dispatch(alertActions.warning(outboundCts.message));
                        dispatch(outboundFetched());
                    }
                },
                error => {
                    dispatch(success([]));
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(outboundCts) { return { type: outboundConstants.OUTBOUND_CTS, outboundCts } }
}
function getBookingForCTSTandem(bookingRef, branch) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(isSuccess(null));
        outboundServices.getBookingForCTSTandem(bookingRef, branch)
            .then(
                outboundBookingCtsTandem => {
                    if (outboundBookingCtsTandem.length > 0) {
                        dispatch(success(outboundBookingCtsTandem));
                        dispatch(outboundFetched());
                    } else {
                        dispatch(success([]));
                        dispatch(alertActions.warning(outboundBookingCtsTandem.message));
                        dispatch(outboundFetched());
                    }
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(outboundBookingCtsTandem) { return { type: outboundConstants.OUTBOUND_BOOKING_CTS_TANDEM, outboundBookingCtsTandem } }
}
function getBookingForCTS(bookingRef, branch) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(isSuccess(null));
        outboundServices.getBookingForCTS(bookingRef, branch)
            .then(
                outboundBookingCts => {
                    if (outboundBookingCts.length > 0) {
                        dispatch(success(outboundBookingCts));
                        dispatch(outboundFetched());
                    } else {
                        dispatch(success([]));
                        dispatch(alertActions.warning(outboundBookingCts.message));
                        dispatch(outboundFetched());
                    }
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(success([]));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(outboundBookingCts) { return { type: outboundConstants.OUTBOUND_BOOKING_CTS, outboundBookingCts } }
}
function createBookingCts(payload, printPayload, user, booking, cyAdd, wbTrData) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(isSuccess(null));
        dispatch(userActions.notallowLeavePage());
        outboundServices.createBookingCts(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    let printData = [...printPayload];
                    printData[0].ctsNum = success.ctsNum;
                    if(wbTrData){
                        let wbTrDataF = {...wbTrData};
                        wbTrDataF.ctsNum = success.ctsNum;
                        // TruckerWB(wbTrDataF);
                        CTSANDCBS(printData, user, booking, cyAdd, "CTSCBS", wbTrDataF);
                    }
                    else {
                        CTSANDCBS(printData, user, booking, cyAdd, "CTSCBS", null);
                    }
                    dispatch(isSuccess(printData));
                    dispatch(alertActions.success('New CTS was added successfully'));
                    // CTSANDCBS({ ...printPayload, ctsNum: success.ctsNum }, user, booking, cyAdd, "CTSCBS");
                    // dispatch(isSuccess({ ...printPayload, ctsNum: success.ctsNum }));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    }
}
function updateCTSNum(payload, CtsNum, printPayload, user, booking, cyAdd, isPrint) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(isSuccess(null));
        dispatch(userActions.notallowLeavePage());
        outboundServices.updateCTSNum(payload, CtsNum)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.success('CTS was updated successfully'));
                    if (isPrint) {
                        CTSANDCBS(printPayload, user, booking, cyAdd, "CTSCBS", null);
                        setTimeout(() => {
                            window.location.href = `/outbound/cts`;                            
                        }, 1000);
                    }
                    else {
                        window.location.href = `/outbound/cts`;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    }
}
function deleteByCTSNum(id, type, branch) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        outboundServices.deleteByCTSNum(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('CTS was deleted successfully'))
                    if (type === 'specific') {
                        window.location.href = `/outbound/cts`;
                    }
                    else dispatch(loadCts(0, 10, null, null, branch));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    // if (type === 'specific') dispatch(getCTS(id));
                    if (type !== 'specific') dispatch(loadCts(0, 10, null, null, branch));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
//end of cts
//waybill
// function loadWayBill(voyageNum, skip, take, filter, search) {
// function loadWayBill(skip, take, filter, search, firstQuery) {
function loadWayBill(skip, take, filter, search) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(userActions.allowLeavePage());
        // outboundServices.loadWayBill(voyageNum, skip, take, filter, search)
        // outboundServices.loadWayBill(skip, take, filter, search, firstQuery)
        outboundServices.loadWayBill(skip, take, filter, search)
            .then(
                waybill => {
                    if (waybill.length > 0) {
                        dispatch(success(waybill));
                        dispatch(outboundFetched());
                    } else {
                        dispatch(alertActions.warning(waybill.message));
                        dispatch(outboundFetched());
                    }
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(waybill) { return { type: outboundConstants.LOAD_WAYBILL, waybill } }
}
function getWayBill(WayBillRef) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(userActions.allowLeavePage());
        outboundServices.getWayBill(WayBillRef)
            .then(
                outboundWaybill => {
                    dispatch(success(outboundWaybill));
                    dispatch(outboundFetched());
                    // if (outboundWaybill.length > 0) {
                    //     dispatch(success(outboundWaybill));
                    //     dispatch(outboundFetched());
                    // } else {
                    //     dispatch(alertActions.warning(outboundWaybill.message));
                    //     dispatch(outboundFetched());
                    // }
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(outboundWaybill) { return { type: outboundConstants.OUTBOUND_WAYBILL, outboundWaybill } }
}
function getWayBillTandem(WayBillRef) {
    return dispatch => {
        dispatch(outboundFetching());
        outboundServices.getWayBill(WayBillRef)
            .then(
                outboundWaybillTandem => {
                    dispatch(success(outboundWaybillTandem));
                    dispatch(outboundFetched());
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(outboundWaybillTandem) { return { type: outboundConstants.OUTBOUND_WAYBILL_TANDEM, outboundWaybillTandem } }
}
// function getBookingForWayBill(bookingRef, branch, voyageNum) {
function getBookingForWayBill(bookingRef, branch) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(isSuccess(null));
        // outboundServices.getBookingForWayBill(bookingRef, branch, voyageNum)
        outboundServices.getBookingForWayBill(bookingRef, branch)
            .then(
                outboundBookingWaybill => {
                    // dispatch(success(outboundBookingWaybill));
                    // dispatch(outboundFetched());
                    if (outboundBookingWaybill && outboundBookingWaybill.booking && outboundBookingWaybill.terms) {
                        dispatch(success(outboundBookingWaybill));
                        dispatch(outboundFetched());
                    } else {
                        dispatch(success([]));
                        dispatch(alertActions.warning(outboundBookingWaybill.message));
                        dispatch(outboundFetched());
                    }
                },
                error => {
                    dispatch(success([]));
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(outboundBookingWaybill) { return { type: outboundConstants.OUTBOUND_BOOKING_WAYBILL, outboundBookingWaybill } }
}
function getBookingForWayBillTandem(bookingRef, branch) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(isSuccess(null));
        outboundServices.getBookingForWayBillTandem(bookingRef, branch)
            .then(
                outboundBookingTandemWaybill => {
                    if (outboundBookingTandemWaybill && outboundBookingTandemWaybill.booking && outboundBookingTandemWaybill.terms) {
                        dispatch(success(outboundBookingTandemWaybill));
                        dispatch(outboundFetched());
                    } else {
                        dispatch(success([]));
                        dispatch(alertActions.warning(outboundBookingTandemWaybill.message));
                        dispatch(outboundFetched());
                    }
                },
                error => {
                    dispatch(success([]));
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(outboundBookingTandemWaybill) { return { type: outboundConstants.OUTBOUND_BOOKING_WAYBILL_TANDEM, outboundBookingTandemWaybill } }
}
function createWayBill(payload, printPayload, user, isTandem, payloadTandem, printPayloadTandem, containerCTS, wbTrData) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(isSuccess(null));
        dispatch(userActions.notallowLeavePage());
        outboundServices.createWayBill(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    let printData = { ...printPayload, wayBIllRef: success.wayBIllRef, datePrepared: success.datePrepared, placedIssuedAddress: success.placeIssuedAddress };
                    if(containerCTS){
                        printData.ctsNum = containerCTS;
                    }
                    let newWBTR = {...wbTrData};
                    if(newWBTR){
                        if(newWBTR.detail && newWBTR.detail.length > 0){
                            newWBTR.detail[0].wayBIllRef = success.wayBIllRef;
                        }
                    }
                    // dispatch(isSuccess({ ...printPayload, wayBIllRef: success.wayBIllRef, datePrepared: success.datePrepared, placedIssuedAddress: success.placeIssuedAddress }));
                    if(isTandem && payloadTandem && printPayloadTandem){
                        dispatch(createWayBillTandem(payloadTandem, printPayloadTandem, user, printData, newWBTR));
                    } else {
                        WayBill(printData, user, true, [printData], null, newWBTR);
                        dispatch(alertActions.success('New waybill was added successfully'));
                        setTimeout(() => {
                            window.location.href = `/outbound/waybill`;                            
                        }, 1000);
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    }
}
function createWayBillTandem(payload, printPayload, user, firstData, wbTrData) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(isSuccess(null));
        dispatch(userActions.notallowLeavePage());
        outboundServices.createWayBill(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    let data = { ...printPayload, wayBIllRef: success.wayBIllRef, datePrepared: success.datePrepared, placedIssuedAddress: success.placeIssuedAddress };
                    // let ctsData = [...firstData, ...printPayload];
                    let ctsData = [];
                    ctsData.push(firstData);
                    ctsData.push(data);
                    let newWBTR = {...wbTrData};
                    if(newWBTR){
                        if(newWBTR.detail && newWBTR.detail.length > 0){
                            newWBTR.detail[1].wayBIllRef = success.wayBIllRef;
                        }
                    }
                    WayBill(data, user, true, ctsData, firstData, newWBTR);
                    // dispatch(isSuccess({ ...printPayload, wayBIllRef: success.wayBIllRef, datePrepared: success.datePrepared, placedIssuedAddress: success.placeIssuedAddress }));
                    dispatch(alertActions.success('New waybill was added successfully'));
                    setTimeout(() => {
                        window.location.href = `/outbound/waybill`;                        
                    }, 1000);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    }
}
function updateWayBillRef(wayBillRef, payload, printPayload, user, otherData, ctsData) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(isSuccess(null));
        dispatch(userActions.notallowLeavePage());
        outboundServices.updateWayBillRef(wayBillRef, payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    WayBill({ ...printPayload, wayBIllRef: wayBillRef }, user, true, ctsData, otherData);
                    dispatch(alertActions.success('Waybill was updated successfully'));
                    setTimeout(() => {
                        window.location.href = `/outbound/waybill`;                        
                    }, 1000);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    }
}
// function deleteByWayBill(voyageNum, id, type) {
function deleteByWayBill(id, type) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        outboundServices.deleteByWayBill(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Waybill was deleted successfully'))
                    if (type === 'specific') {
                        window.location.href = `/outbound/waybill`;
                    }
                    else dispatch(loadWayBill(0, 20));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    if (type === 'specific') dispatch(getWayBill(id));
                    // else dispatch(loadWayBill(voyageNum, 0, 20));
                    else dispatch(loadWayBill(0, 20));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}
function shipperOwnContainerCts(payload, data, wbTrData) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(isSuccess(null));
        outboundServices.shipperOwnContainerCts(payload)
            .then(
                success => {
                    dispatch(outboundSubmitted());
                    dispatch(createWayBill(data.payload, data.printPayload, data.user, data.isTandem, data.payloadTandem, data.printPayloadTandem, success.ctsNum, wbTrData));
                    dispatch(alertActions.success(success.message));
                },
                error => {
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    }
}
function updateShipperOwnCVCts(ctsNum, payload) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(isSuccess(null));
        dispatch(userActions.notallowLeavePage());
        outboundServices.updateShipperOwnCVCts(ctsNum, payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.success(success.message));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    }
}

function generateExemptionCharge(payload) {
    return dispatch => {
        // dispatch(outboundFetching());
        dispatch(exemptionChargeLoading());
        dispatch(userActions.notallowLeavePage());
        outboundServices.generateExemptionCharge(payload)
            .then(
                ExemptionCharge => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(success(ExemptionCharge));
                    // dispatch(outboundFetched());
                    dispatch(exemptionChargeLoaded());
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(success(null));
                    // dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(exemptionChargeLoaded());
                }
            );
    }
    function success(ExemptionCharge) { return { type: outboundConstants.OUTBOUND_EXEMPTION_CHARGE, ExemptionCharge } }
}
function generateExemptionChargeTandem(payload) {
    return dispatch => {
        // dispatch(outboundFetching());
        dispatch(exemptionChargeLoading());
        dispatch(userActions.notallowLeavePage());
        outboundServices.generateExemptionCharge(payload)
            .then(
                ExemptionChargeTandem => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(success(ExemptionChargeTandem));
                    // dispatch(outboundFetched());
                    dispatch(exemptionChargeLoaded());
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(success(null));
                    // dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(exemptionChargeLoaded());
                }
            );
    }
    function success(ExemptionChargeTandem) { return { type: outboundConstants.OUTBOUND_EXEMPTION_CHARGE_TANDEM, ExemptionChargeTandem } }
}
//end of waybill
//buil up
function getWayBIllBuildUp(voyageNUm, branch, filter) {
    return dispatch => {
        dispatch(outboundFetching());
        outboundServices.getWayBIllBuildUp(voyageNUm, branch, filter)
            .then(
                buildUp => {
                    if (buildUp && buildUp.wayBIll && buildUp.wayBIll.length > 0) {
                        dispatch(outboundFetched());
                        dispatch(success(buildUp));
                    } else {
                        dispatch(alertActions.warning(buildUp.message));
                        dispatch(outboundFetched());
                    }
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(buildUp) { return { type: outboundConstants.BUILD_UP, buildUp } }
}
function getWayBillByVoyageNum(voyageNum, search, branch) {
    return dispatch => {
        dispatch(outboundFetching());
        outboundServices.getWayBillByVoyageNum(voyageNum, search, branch)
            .then(
                buildUp => {
                    dispatch(outboundFetched());
                    dispatch(success(buildUp));
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(buildUp) { return { type: outboundConstants.BUILD_UP, buildUp } }
}
function isWithPermit(payload, voyageNUm, branch) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        outboundServices.isWithPermit(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(outboundSubmitted());
                    dispatch(getWayBIllBuildUp(voyageNUm, branch));
                    dispatch(alertActions.success('Successfully Build-up Permit Changed.'));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}
//end of build up
//loadlist
function groupWayBillbyRelease(voyageNUm) {
    return dispatch => {
        dispatch(outboundFetching());
        outboundServices.groupWayBillbyRelease(voyageNUm)
            .then(
                loadlistRelease => {
                    dispatch(outboundFetched());
                    dispatch(success(loadlistRelease));
                    if (loadlistRelease.length === 0) dispatch(alertActions.warning(loadlistRelease.message ? loadlistRelease.message : 'No data found'));
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(loadlistRelease) { return { type: outboundConstants.OUTBOUND_LOADLIST_RELEASE, loadlistRelease } }
}
function updateLoadListReleaseType(payload, notification) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        outboundServices.updateLoadListReleaseType(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    if(notification){
                        dispatch(notificationActions.CreateNotification(notification));
                    }
                    dispatch(alertActions.success(`Release type successfully chaged to ${payload.releaseType}.`));
                    dispatch(groupWayBillbyRelease(payload.voyageNum));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}
function deleteLoadListByRelease(payload) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        outboundServices.deleteLoadListByRelease(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Loadlist deleted successfully.'));
                    dispatch(groupWayBillbyRelease(payload.voyageNum));

                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}
function createLoadList(payload, notification) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        outboundServices.createLoadList(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    if(notification){
                        dispatch(notificationActions.CreateNotification(notification));
                    }
                    dispatch(alertActions.success('Successfully added to loadlist.'));
                    setTimeout(() => {
                        window.location.href = `/outbound/loadList/${payload.voyageNum}`;                        
                    }, 1000);
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
}
function getWayBillReleaseType(voyageNum, ReleaseId, search) {
    return dispatch => {
        dispatch(outboundFetching());
        outboundServices.getWayBillReleaseType(voyageNum, ReleaseId, search)
            .then(
                loadList => {
                    dispatch(outboundFetched());
                    dispatch(success(loadList));
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(loadList) { return { type: outboundConstants.LOAD_LIST, loadList } }
}
function acknowledgeRelease(payload, notification) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        outboundServices.acknowledgeRelease(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    if(notification){
                        dispatch(notificationActions.CreateNotification(notification));
                    }
                    dispatch(alertActions.success('Confirmed successfully.'));
                    dispatch(getWayBillReleaseType(payload.voyageNum, payload.releaseId));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(confirmPromptActions.hide());
                }
            );
    }
}
function updateLoadList(payload, releaseId, link, notification) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        outboundServices.updateLoadList(payload, releaseId)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    if(notification){
                        dispatch(notificationActions.CreateNotification(notification));
                    }
                    dispatch(alertActions.success(payload.status === 'add' ? 'Successfully added to loadlist.' : 'Loadlist cancelled successfully.'));
                    if (payload.status === 'add') {
                        setTimeout(() => {
                            window.location.href = link;
                        }, 1000);
                    }
                    else dispatch(getWayBillReleaseType(payload.voyageNum, releaseId));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(confirmPromptActions.hide());
                }
            );
    }
}
//end of loadlist
//tallsheet
function readListTallySheetByVoyageNum(voyageNUm) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(userActions.allowLeavePage());
        outboundServices.readListTallySheetByVoyageNum(voyageNUm)
            .then(
                tallySheets => {
                    if (tallySheets.message) {
                        dispatch(success([]));
                        dispatch(alertActions.warning(tallySheets.message));
                        dispatch(outboundFetched());
                    } else {
                        dispatch(success(tallySheets));
                        dispatch(outboundFetched());
                    }
                },
                error => {
                    dispatch(success([]));
                    dispatch(outboundFetched());
                    dispatch(alertActions.warning(error.toString()));
                }
            );
    }
    function success(tallySheets) { return { type: outboundConstants.TALLY_SHEETS, tallySheets } }
}
function getListForTallySheet(voyageNUm, branch) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(userActions.allowLeavePage());
        outboundServices.getListForTallySheet(voyageNUm, branch)
            .then(
                listForCreateTallySheet => {
                    dispatch(outboundFetched());
                    dispatch(success(listForCreateTallySheet));
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.warning(error.toString()));
                }
            );
    }
    function success(listForCreateTallySheet) { return { type: outboundConstants.LIST_FOR_CREATE_TALLY_SHEET, listForCreateTallySheet } }
}
function createTallySheet(payload, voyageNUm) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        outboundServices.createTallySheet(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.success('Successfully added to tally sheet.'));
                    window.location.href = `/outbound/tallySheet/${voyageNUm}`;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function getTallySheetCode(tallysheetCode) {
    return dispatch => {
        dispatch(outboundFetching());
        outboundServices.getTallySheetCode(tallysheetCode)
            .then(
                tallySheet => {
                    dispatch(success(tallySheet));
                    dispatch(outboundFetched());
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(tallySheet) { return { type: outboundConstants.TALLY_SHEET, tallySheet } }
}
function updateTallySheet(payload, voyageNUm, tallysheetCode) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        outboundServices.updateTallySheet(payload, tallysheetCode)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.success('Tally sheet updated successfully.'));
                    window.location.href = `/outbound/tallySheet/${voyageNUm}`;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function createFinalTallySheet(payload, notification) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        outboundServices.createFinalTallySheet(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(outboundSubmitted());
                    if(notification){
                        dispatch(notificationActions.CreateNotification(notification));
                    }
                    dispatch(alertActions.success('Tally sheet updated successfully.'));
                    if (payload.tallySheetType === "Loading") {
                        dispatch(readListTallySheetByVoyageNum(payload.voyageNum));
                    }
                    else {
                        dispatch(inboundActions.readTallySheetByVoyageNum(payload.voyageNum, payload.destination));
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function updateFinalTallySheet(payload, id, notification) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        outboundServices.updateFinalTallySheet(payload, id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(outboundSubmitted());
                    if(notification){
                        dispatch(notificationActions.CreateNotification(notification));
                    }
                    dispatch(alertActions.success('Tally sheet updated successfully.'));
                    if (payload.tallySheetType === "Loading") {
                        dispatch(readListTallySheetByVoyageNum(payload.voyageNum));
                    }
                    else {
                        dispatch(inboundActions.readTallySheetByVoyageNum(payload.voyageNum, payload.destination));
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function deleteByTallySheet(id, type, voyageNum) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        outboundServices.deleteByTallySheet(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Tally sheet was deleted successfully'));
                    if (type === 'specific') {
                        setTimeout(() => {
                            window.location.href = `/outbound/tallySheet/${voyageNum}`;
                        }, 1000);
                    }
                    else dispatch(readListTallySheetByVoyageNum(voyageNum));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    if (type === 'specific') dispatch(getTallySheetCode(id));
                    else dispatch(readListTallySheetByVoyageNum(voyageNum));
                    dispatch(alertActions.error(error.toString()))
                }
            );
    }
}
function getVoyageLoadingReport(id, name) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        outboundServices.getVoyageLoadingReport(id)
            .then(
                LoadingReportData => {
                    dispatch(userActions.allowLeavePage());
                    // dispatch(alertActions.hide("info"));
                    dispatch(outboundSubmitted());
                    if (name === 'cargo costing') {
                        // CargoCostingManifest(LoadingReportData)
                        dispatch(success(LoadingReportData));
                    }
                    else if (name === 'coasting') {
                        CoastingManifest(LoadingReportData)
                    }
                    // else {
                    //     LoadingReport(LoadingReportData)
                    // }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.hide("info"));
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                   
                }
            )
    }
    function success(LoadingReportData) { return { type: outboundConstants.GET_VOYAGE_LOADING_REPORT, LoadingReportData } }
}

function getVoyageLoadingReportTallysheet(id) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        outboundServices.getVoyageLoadingReportTallysheet(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    LoadingReport(success)
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}

function getVoyageLoadingReportTallysheetReturnData(id) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        outboundServices.getVoyageLoadingReportTallysheet(id)
            .then(
                LoadingReportTallySheetData => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(success(LoadingReportTallySheetData));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
    function success(LoadingReportTallySheetData) { return { type: outboundConstants.GET_VOYAGE_LOADING_REPORT_TALLYSHEET, LoadingReportTallySheetData } }
}

//end of tallysheet
//stowage
function getListVoyageWithStowagePlan(voyageNUm) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(userActions.allowLeavePage());
        outboundServices.getListVoyageWithStowagePlan(voyageNUm)
            .then(
                stowage => {
                    if (stowage.length > 0) {
                        dispatch(success(stowage));
                        dispatch(outboundFetched());
                    } else {
                        dispatch(success([]));
                        dispatch(alertActions.warning('No record found'));
                        dispatch(outboundFetched());
                    }
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(stowage) { return { type: outboundConstants.STOWAGE, stowage } }
}
function getVoyageStowagePlan(voyageNUm) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(userActions.allowLeavePage());
        outboundServices.getVoyageStowagePlan(voyageNUm)
            .then(
                stowageForCreate => {
                    dispatch(outboundFetched());
                    if (stowageForCreate.message) dispatch(alertActions.warning(stowageForCreate.message));
                    dispatch(success(stowageForCreate));
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(stowageForCreate) { return { type: outboundConstants.STOWAGE_FOR_CREATE, stowageForCreate } }
}
function createStowagePlan(payload, voyageNUm) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        outboundServices.createStowagePlan(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.success('Successfully added to stowage plan.'));
                    window.location.href = `/outbound/stowage/${voyageNUm}`;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function getStowagePlanCode(stowagePlanCode) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(userActions.allowLeavePage());
        outboundServices.getStowagePlanCode(stowagePlanCode)
            .then(
                stowageCode => {
                    dispatch(success(stowageCode));
                    dispatch(outboundFetched());
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(stowageCode) { return { type: outboundConstants.STOWAGE_CODE, stowageCode } }
}
function deleteByStowagePlanCode(id, type, voyageNum) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        outboundServices.deleteByStowagePlanCode(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('Stowage plan was deleted successfully'));
                    if (type === 'specific') {
                        setTimeout(() => {
                            window.location.href = `/outbound/stowage/${voyageNum}`;
                        }, 1000);
                    }
                    else dispatch(getListVoyageWithStowagePlan(voyageNum));
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    }
}
function updateStowagePlan(payload, voyageNUm, stowagePlanCode) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        outboundServices.updateStowagePlan(payload, stowagePlanCode)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.success('Stowage plan updated successfully.'));
                    window.location.href = `/outbound/stowage/${voyageNUm}`;
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
function getVoyageNumPrintLoaded(id) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        outboundServices.getVoyageNumPrintLoaded(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.hide("info"));
                    dispatch(outboundSubmitted());
                    StowagePlanPdf(success)
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                }
            )
    }
}
//end of stowage
//loading confirmation
function getLoadingConfirmationByVoyageNum(voyageNUm) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(userActions.allowLeavePage());
        outboundServices.getLoadingConfirmationByVoyageNum(voyageNUm)
            .then(
                loadingConfirmation => {
                    dispatch(outboundFetched());
                    dispatch(success(loadingConfirmation));
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(loadingConfirmation) { return { type: outboundConstants.LOADING_CONFIRMATION, loadingConfirmation } }
}
function SentUnsent(bookingRef, isSent, voyageNUm) {
    return dispatch => {
        outboundServices.SentUnsent(bookingRef, isSent, voyageNUm)
            .then(
                success => {
                    dispatch(confirmPromptActions.hide());
                    dispatch(getLoadingConfirmationByVoyageNum(voyageNUm));
                    dispatch(alertActions.success('Status updated successfully'));
                },
                error => {
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    }
}
//end of loading confirmation

//not use
function getAllCTS() {
    return dispatch => {
        dispatch(outboundFetching());
        outboundServices.getAllCTS()
            .then(
                outboundAllCts => {
                    if (outboundAllCts.length > 0) {
                        dispatch(success(outboundAllCts));
                        dispatch(outboundFetched());
                    } else {
                        dispatch(alertActions.warning(outboundAllCts.message));
                        dispatch(outboundFetched());
                    }
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(outboundAllCts) { return { type: outboundConstants.OUTBOUND_ALL_CTS, outboundAllCts } }
}
function moveWayBillRef(payload, voyageNum, releaseNum) {
    return dispatch => {
        dispatch(userActions.notallowLeavePage());
        outboundServices.moveWayBillRef(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    if (payload.releaseType === 'Draft') {
                        dispatch(getWayBillReleaseType(voyageNum, releaseNum));
                        dispatch(alertActions.success('Successfully cancelled.'));
                    } else if (payload.releaseType === 'Partial Release') {
                        dispatch(alertActions.success('Successfully added to load list.'));
                        setTimeout(() => {
                            window.location.href = `/outbound/loadList/${voyageNum}/read/${releaseNum}`;
                        }, 1000);
                    } else if (payload.releaseType === 'Final Release') {
                        dispatch(getWayBillReleaseType(voyageNum, releaseNum));
                        dispatch(alertActions.success('Successfully released.'));
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(getWayBillReleaseType(voyageNum, releaseNum));
                    dispatch(alertActions.error(error.toString()));
                    dispatch(confirmPromptActions.hide());
                }
            );
    }
}

// Voyage List
function getVoyageBuildUp(branchCode, search) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(userActions.allowLeavePage());
        outboundServices.getVoyageBuildUp(branchCode, search)
            .then(
                voyageBuildUpList => {
                    dispatch(outboundFetched());
                    // if (voyageBuildUpList.length > 0) dispatch(success(voyageBuildUpList));
                    // else dispatch(alertActions.warning(voyageBuildUpList.message));
                    dispatch(success(voyageBuildUpList));
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(voyageBuildUpList) { return { type: outboundConstants.VOYAGE_BUILDUP_LIST, voyageBuildUpList } }
}
function getVoyageLoadList(branchCode, search) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(userActions.allowLeavePage());
        outboundServices.getVoyageLoadList(branchCode, search)
            .then(
                voyageLoadList => {
                    dispatch(outboundFetched());
                    // if (voyageLoadList.length > 0) dispatch(success(voyageLoadList));
                    // else dispatch(alertActions.warning(voyageLoadList.message));
                    dispatch(success(voyageLoadList));
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(voyageLoadList) { return { type: outboundConstants.VOYAGE_LOAD_LIST, voyageLoadList } }
}
function getVoyageTallySheetList(branchCode, search) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(userActions.allowLeavePage());
        outboundServices.getVoyageTallySheetList(branchCode, search)
            .then(
                voyageTallySheetList => {
                    dispatch(outboundFetched());
                    // if (voyageTallySheetList.length > 0) dispatch(success(voyageTallySheetList));
                    // else dispatch(alertActions.warning(voyageTallySheetList.message));
                    dispatch(success(voyageTallySheetList));
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(voyageTallySheetList) { return { type: outboundConstants.VOYAGE_TALLYSHEET_LIST, voyageTallySheetList } }
}
function getVoyageStowagePlanList(branchCode, search) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(userActions.allowLeavePage());
        outboundServices.getVoyageStowagePlanList(branchCode, search)
            .then(
                voyageStowagePlanList => {
                    dispatch(outboundFetched());
                    // if (voyageStowagePlanList.length > 0) dispatch(success(voyageStowagePlanList));
                    // else dispatch(alertActions.warning(voyageStowagePlanList.message));
                    dispatch(success(voyageStowagePlanList));
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(voyageStowagePlanList) { return { type: outboundConstants.VOYAGE_STOWAGEPLAN_LIST, voyageStowagePlanList } }
}
function getVoyageLoadingConfirmationList(branchCode, search) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(userActions.allowLeavePage());
        outboundServices.getVoyageLoadingConfirmationList(branchCode, search)
            .then(
                voyageLoadingConfirmationList => {
                    dispatch(outboundFetched());
                    // if (voyageLoadingConfirmationList.length > 0) dispatch(success(voyageLoadingConfirmationList));
                    // else dispatch(alertActions.warning(voyageLoadingConfirmationList.message));
                    dispatch(success(voyageLoadingConfirmationList));
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(voyageLoadingConfirmationList) { return { type: outboundConstants.VOYAGE_LOADING_CONFIRMATION_LIST, voyageLoadingConfirmationList } }
}
function getVoyageWayBill(branchCode) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(userActions.allowLeavePage());
        outboundServices.getVoyageWayBill(branchCode)
            .then(
                getVoyageWayBillList => {
                    dispatch(outboundFetched());
                    // if (getVoyageWayBillList.length > 0) dispatch(success(getVoyageWayBillList));
                    // else dispatch(alertActions.warning(getVoyageWayBillList.message));
                    dispatch(success(getVoyageWayBillList));
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(getVoyageWayBillList) { return { type: outboundConstants.VOYAGE_WAYBILL_LIST, getVoyageWayBillList } }
}
function getVoyageForReguidingList(branchCode, search) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(userActions.allowLeavePage());
        outboundServices.getVoyageForReguidingList(branchCode, search)
            .then(
                getVoyageReguidingList => {
                    dispatch(outboundFetched());
                    // if (getVoyageReguidingList.length > 0) dispatch(success(getVoyageReguidingList));
                    // else dispatch(alertActions.warning(getVoyageReguidingList.message));
                    dispatch(success(getVoyageReguidingList));
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(getVoyageReguidingList) { return { type: outboundConstants.VOYAGE_REGUIDING_LIST, getVoyageReguidingList } }
}

// Reguide

function getReguideVoyage(voyageNum, search) {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(userActions.allowLeavePage());
        outboundServices.getReguideVoyage(voyageNum, search)
            .then(
                getReguideVoyage => {
                    dispatch(outboundFetched());
                    if (getReguideVoyage.length > 0) dispatch(success(getReguideVoyage));
                    else dispatch(alertActions.warning(getReguideVoyage.message));
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(getReguideVoyage) { return { type: outboundConstants.GET_REGUIDE_VOYAGE, getReguideVoyage } }
}

function getVoyageScheduleForReguiding(data) {
    return dispatch => {
        dispatch(outboundFetching());
        outboundServices.getVoyageScheduleForReguiding(data)
            .then(
                getVoyageScheduleForReguide => {
                    dispatch(outboundFetched());
                    if (getVoyageScheduleForReguide.length > 0) dispatch(success(getVoyageScheduleForReguide));
                    else dispatch(alertActions.warning(getVoyageScheduleForReguide.message));
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(getVoyageScheduleForReguide) { return { type: outboundConstants.GET_VOYAGESCHEDULE_FOR_REGUIDE, getVoyageScheduleForReguide } }
}

function changeVessel(payload, voyageNum) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        outboundServices.changeVessel(payload, voyageNum)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.success('Voyage Changed Vessel Successfully.'));
                    dispatch(getReguideVoyage(voyageNum, null));
                    dispatch(confirmPromptActions.hide());
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(confirmPromptActions.hide());
                }
            )
    }
}
function voyageTransfer(payload, voyageNum) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(userActions.notallowLeavePage());
        outboundServices.voyageTransfer(payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.success('Voyage Transfered Successfully.'));
                    dispatch(getReguideVoyage(voyageNum, null));
                    dispatch(confirmPromptActions.hide());
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()));
                    dispatch(confirmPromptActions.hide());
                }
            )
    }
}
function getVoyageCroAccounting() {
    return dispatch => {
        dispatch(outboundFetching());
        dispatch(userActions.allowLeavePage());
        outboundServices.getVoyageCroAccounting()
            .then(
                voyageCROAcctgList => {
                    dispatch(outboundFetched());
                    // if (voyageCROAcctgList.length > 0) dispatch(success(voyageCROAcctgList));
                    // else dispatch(alertActions.warning(voyageCROAcctgList.message));
                    dispatch(success(voyageCROAcctgList));
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(voyageCROAcctgList) { return { type: outboundConstants.VOYAGE_CROACCTG_LIST, voyageCROAcctgList } }
}
function getWayBIllWithDemmurage(voyageNum) {
    return dispatch => {
        dispatch(outboundFetching());
        outboundServices.getWayBIllWithDemmurage(voyageNum)
            .then(
                CROAcctgData => {
                    dispatch(outboundFetched());
                    dispatch(success(CROAcctgData));
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(CROAcctgData) { return { type: outboundConstants.GET_CROACCTG_BY_VOYAGE, CROAcctgData } }
}

function getWayBIllCROAccounting(voyageNum) {
    return dispatch => {
        dispatch(outboundFetching());
        outboundServices.getWayBIllCROAccounting(voyageNum)
            .then(
                waybillCROACCNT => {
                    dispatch(success(waybillCROACCNT));
                    dispatch(outboundFetched());
                },
                error => {
                    dispatch(outboundFetched());
                    // dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(waybillCROACCNT) { return { type: outboundConstants.GET_WAYBILL_BY_VOYAGE_CRO_ACCOUNTING, waybillCROACCNT } }
}

function getWayBIllRefCROAccounting(wayBIll) {
    return dispatch => {
        dispatch(outboundFetching());
        outboundServices.getWayBIllRefCROAccounting(wayBIll)
            .then(
                WaybillDataCROAccounting => {
                    dispatch(outboundFetched());
                    dispatch(success(WaybillDataCROAccounting));
                },
                error => {
                    dispatch(outboundFetched());
                    // dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(WaybillDataCROAccounting) { return { type: outboundConstants.GET_WAYBILL_DATA_CRO_ACCOUTING, WaybillDataCROAccounting } }
}
function updateCroAccounting(waybillRef, payload, isCRO, voyage) {
    return dispatch => {
        dispatch(outboundSubmitting());
        dispatch(isSuccess(null));
        dispatch(userActions.notallowLeavePage());
        outboundServices.updateCroAccounting(waybillRef, payload)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.success(success.message));
                    if(isCRO){
                        window.location.href = `/CROAccounting/Posting/voyage/${voyage}`;
                    }
                    else{
                        window.location.href = `/outbound/CROAcctg/read/${waybillRef}`;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(outboundSubmitted());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    }
}

function getPrevVoyage(voyageNum) {
    return dispatch => {
        dispatch(outboundFetching());
        outboundServices.getPrevVoyage(voyageNum)
            .then(
                PrevVoyage => {
                    dispatch(outboundFetched());
                    dispatch(success(PrevVoyage));
                },
                error => {
                    dispatch(outboundFetched());
                    dispatch(success(null));
                    dispatch(alertActions.error(error.toString()));
                }
            );
    }
    function success(PrevVoyage) { return { type: outboundConstants.GET_PREVIOUS_VOYAGE, PrevVoyage } }
}